'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["receiveAnalytics", "fetchSettings", "fetchSettingsIfNeeded", "fetchBusinessUnits", "fetchPortalScopes", "businessUnitsRequestState", "pageChange", "hasEmailSendingFreeScope", "tab", "push", "shouldShowBranding", "location", "ungatedForShareEmbedV3", "ungatedForNewEditorAccess", "ungatedForDataEnrichmentBeta", "hasBusinessUnitAccess"];
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchSettingsIfNeeded as fetchSettingsIfNeededAction } from 'forms-utils-lib/settings/actions';
import { push as _push } from 'FormsUI/actions/HistoryActions';
import FormsDashboard from 'FormsUI/components/dashboard/FormsDashboard';
import FormsScriptBetaAlert from 'FormsUI/components/editor/FormsScriptBetaAlert';
import FormsNewEditorBreezeOptIn from 'FormsUI/components/editor/FormsNewEditorBreezeOptIn';
import { hasEmailSendingFreeScope as hasEmailSendingFreeScopeFromSelector, hasComparisonToolAccess, shouldShowBranding as shouldShowBrandingFromSelector, hasBusinessUnitAccess as hasBusinessUnitAccessFromSelector } from 'FormsUI/selectors/Scope';
import { isUngatedForShareEmbedV3, isUngatedForNewEditorAccess, isUngatedForBusinessUnitPicker, isUngatedForDataEnrichmentBeta } from 'FormsUI/selectors/Gates';
import { receiveAnalytics as receiveAnalyticsAction, changeAnalyticsSelectedForms as changeAnalyticsSelectedFormsAction, changeAnalyticsSearchQuery as changeAnalyticsSearchQueryFromAction } from 'FormsUI/actions/Dashboard';
import { fetchPortalScopes as fetchPortalScopesAction } from 'FormsUI/actions/PortalScopes';
import { getAnalyticsDateRange, getAnalyticsBusinessUnitId, getAnalyticsSelectedForms, getAnalyticsSearchQuery } from 'FormsUI/selectors/Dashboard';
import { getBusinessUnits, getBusinessUnitsRequestState } from 'FormsUI/selectors/BusinessUnits';
import { fetchBusinessUnits as fetchBusinessUnitsAction } from 'FormsUI/actions/BusinessUnits';
import { getDashboardRoute } from 'FormsUI/lib/RouteGenerators';
import { fetchSettings as fetchSettingsFromAction } from 'FormsUI/actions/leadinSettings';
import { trackScreen } from 'FormsUI/utils/TrackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FormsDashboardContainer = _ref => {
  let {
      receiveAnalytics,
      fetchSettings,
      fetchSettingsIfNeeded,
      fetchBusinessUnits,
      fetchPortalScopes,
      businessUnitsRequestState,
      pageChange,
      hasEmailSendingFreeScope,
      tab,
      push,
      shouldShowBranding,
      location,
      ungatedForShareEmbedV3,
      ungatedForNewEditorAccess,
      ungatedForDataEnrichmentBeta,
      hasBusinessUnitAccess
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  useEffect(() => {
    trackScreen('dashboard', tab, {
      framework_table: true
    });
  }, [tab]);
  const shouldBeRequested = hasBusinessUnitAccess && businessUnitsRequestState.isNotRequested();
  useEffect(() => {
    if (shouldBeRequested) {
      fetchPortalScopes();
      fetchBusinessUnits();
      fetchSettings();
      receiveAnalytics();
    }
  }, [fetchSettings, fetchPortalScopes, fetchBusinessUnits, receiveAnalytics, shouldBeRequested]);
  useEffect(() => {
    fetchSettingsIfNeeded();
  }, [hasEmailSendingFreeScope, fetchSettingsIfNeeded]);
  const onTabChange = newTab => push(getDashboardRoute(newTab, location));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [ungatedForDataEnrichmentBeta && !ungatedForNewEditorAccess ? /*#__PURE__*/_jsx(FormsNewEditorBreezeOptIn, {}) : null, ungatedForShareEmbedV3 && !ungatedForNewEditorAccess ? /*#__PURE__*/_jsx(FormsScriptBetaAlert, {}) : null, /*#__PURE__*/_jsx(FormsDashboard, Object.assign({}, props, {
      hasBusinessUnitAccess: hasBusinessUnitAccess,
      tab: tab,
      onTabChange: onTabChange,
      onPageChange: pageChange,
      shouldShowBranding: shouldShowBranding,
      ungatedForNewEditorAccess: ungatedForNewEditorAccess
    }))]
  });
};
const mapStateToProps = state => ({
  businessUnits: getBusinessUnits(state),
  analyticsDateRange: getAnalyticsDateRange(state),
  analyticsBusinessUnitId: getAnalyticsBusinessUnitId(state),
  analyticsSelectedForms: getAnalyticsSelectedForms(state),
  analyticsSearchQuery: getAnalyticsSearchQuery(state),
  businessUnitsRequestState: getBusinessUnitsRequestState(state),
  hasEmailSendingFreeScope: hasEmailSendingFreeScopeFromSelector(state),
  portalCreationDate: state.portal && state.portal.created_at,
  hasBusinessUnitAccess: hasBusinessUnitAccessFromSelector(state),
  isComparisonAllowed: hasComparisonToolAccess(state),
  shouldShowBranding: shouldShowBrandingFromSelector(state),
  ungatedForShareEmbedV3: isUngatedForShareEmbedV3(state),
  ungatedForNewEditorAccess: isUngatedForNewEditorAccess(state),
  ungatedForBusinessUnitPicker: isUngatedForBusinessUnitPicker(state),
  ungatedForDataEnrichmentBeta: isUngatedForDataEnrichmentBeta(state)
});
const actionsToBind = {
  push: _push,
  receiveAnalytics: receiveAnalyticsAction,
  fetchSettingsIfNeeded: fetchSettingsIfNeededAction,
  fetchSettings: fetchSettingsFromAction,
  fetchBusinessUnits: fetchBusinessUnitsAction,
  fetchPortalScopes: fetchPortalScopesAction,
  changeAnalyticsSelectedForms: changeAnalyticsSelectedFormsAction,
  changeAnalyticsSearchQuery: changeAnalyticsSearchQueryFromAction
};
export default connect(mapStateToProps, actionsToBind)(FormsDashboardContainer);